<template>
  <div class="products catalog-products-redesign-page" :style="{ backgroundImage: 'url(' + imgPreUrl + 'subsection/qFIvnDEp7ox640.jpg)' }">
    <div class="container">
      <div class="row rounded-shadow product-catalog-layout">
        <div class="col-md-3 col-12 product-filters-column mb-3 mb-md-4">
          <product-filter
            :key="filter_key"
            :categories="categories"
            :subcategories="subcategories"
            :sellers="sellers"
            :cate="cate_filter"
            :subcate="subcate_filter"
            :caliber="caliber_filter"
            :brand="brand_filter"
            :crit="crit_filter"
            :query="query_filter"
            :internalTitle="'Nuestros Productos'"
            :brands="brands"
            :calibers="calibers"
            show-reset
            reset-href="/productos"
            reset-label="Reiniciar todos los filtros"
            reset-btn-class="btn btn-al-rojo-solid btn-sm btn-card ancho-total"
          />
        </div>
        <div class="col-md-9 col-12 product-list-column">
          <div
            :class="[successMessage === '' ? 'd-none' : 'alert alert-success']"
            role="alert"
          >
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              @click="hideMessages()"
            >
              &times;</button
            ><strong>{{ successMessage }}</strong>
          </div>
          <div
            :class="[errorMessage === '' ? 'd-none' : 'alert alert-warning']"
            role="alert"
          >
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              @click="hideMessages()"
            >
              &times;</button
            ><strong>{{ errorMessage }}</strong>
          </div>
          <template v-if="loading">
            <ProductsRedesignSkeleton :card-count="perPage" />
          </template>
          <template v-else>
            <div class="row" v-if="showPagination">
              <div class="col-md-12 products-pagination-bar">
                <ProductsPagination
                  :currentPage="current_page"
                  :availablePages="pages"
                  :finalPage="final_page"
                  :critFilter="crit_filter"
                  :cateFilter="cate_filter"
                  :subcateFilter="subcate_filter"
                  :caliberFilter="caliber_filter"
                  :brandFilter="brand_filter"
                  :queryFilter="query_filter"
                />
              </div>
              <div class="col-md-12">
                <ProductsRow :productsList="products_list" />
              </div>
              <div class="col-md-12 products-pagination-bar">
                <ProductsPagination
                  :currentPage="current_page"
                  :availablePages="pages"
                  :finalPage="final_page"
                  :critFilter="crit_filter"
                  :cateFilter="cate_filter"
                  :subcateFilter="subcate_filter"
                  :caliberFilter="caliber_filter"
                  :brandFilter="brand_filter"
                  :queryFilter="query_filter"
                />
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <GoToTrackingModule />
    <GuideModule />
  </div>
</template>

<script>
import GoToTrackingModule from '@/modules/GoToTrackingModule.vue';
import GuideModule from '@/modules/GuideModule.vue';
import ProductsList from '@/components/products/catalog/ProductsList';
import ProductFilter from '@/views/Catalog/components/ProductFilter/ProductFilter';
import ProductsPagination from '@/views/Catalog/components/ProductsPagination/ProductsPagination';
import ProductsRow from '@/views/Catalog/components/ProductsRow/ProductsRow';
import ProductsRedesignSkeleton from '@/views/Catalog/ProductsRedesign/ProductsRedesignSkeleton/ProductsRedesignSkeleton';
import axios from 'axios';
import _ from 'lodash';
import { config_settings } from '@/config.js';

//HTTP ERROR STATUS
const NOT_FOUND = 404;

export default {
  name: 'allProducts',
  components: {
    ProductsList,
    ProductsRow,
    ProductFilter,
    ProductsPagination,
    ProductsRedesignSkeleton,
    GoToTrackingModule,
    GuideModule,
  },
  props: ['configData'],
  data() {
    return {
      page_title: '',
      page_description: '',
      page_keywords: '',
      imgPreUrl: config_settings.PHOTO_SERVER_URL + '/',
      cod_sub_sec: 24,
      categories: [],
      subcategories: [],
      calibers: [],
      brands: [],
      sellers: [],
      products_list: [],
      product_duplicate: [],
      loading: false,
      pages: [],
      current_page: 1,
      final_page: 1,
      perPage: 12,
      filter_key: 1,
      crit_filter: this.$route.params.crit,
      page_filter: this.$route.params.page,
      cate_filter: this.$route.params.cate,
      subcate_filter: this.$route.params.subcate,
      caliber_filter: this.$route.params.caliber,
      brand_filter: this.$route.params.brand,
      query_filter: this.$route.params.query,
      id_brand: '',
      id_caliber: '',
      criterio: '',
      criterio_categoria: '',
      successMessage: '',
      errorMessage: '',
      showPagination: false,
      filter_category: false,
      childKey: 0,
    };
  },
  metaInfo() {
    return {
      title: this.configData.general.webTitle
        ? 'Catálogo - ' + this.configData.general.webTitle
        : '',
      meta: [
        { name: 'description', content: '' },
        { name: 'keywords', content: '' },
        { name: 'robots', content: 'index' },
      ],
    };
  },
  methods: {
    hideMessages() {
      this.successMessage = '';
      this.errorMessage = '';
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    listar_categorias() {
      this.childKey = this.childKey + 1;
      axios
        .get(config_settings.RESOURCE_SERVER_URL + '/GET/catalog/categories')
        .then(response => {
          this.categories = response.data;
        })
        .catch(error => {});
    },

    listar_subcategorias(valor_categoria) {
      this.childKey = this.childKey + 1;
      axios
        .get(
          config_settings.RESOURCE_SERVER_URL +
            '/GET/catalog/categories/' +
            valor_categoria +
            '/subcategories',
        )
        .then(response => {
          this.subcategories = response.data.subcategories;
        })
        .catch(error => {});
    },

    filtrar_lista_categoria_marca_calibre(
      valor_categoria,
      valor_marca,
      valor_calibre,
      valor_criterio,
    ) {
      this.childKey = this.childKey + 1;
      this.loading = true;
      this.filter_category = true;

      var url =
        '/GET/catalog/products-2xcategory?cat=' +
        valor_categoria +
        '&&xPag=' +
        this.crit;

      if (valor_marca != '' && valor_marca != undefined) {
        url = url + '&&brand=' + valor_marca;
      }
      if (valor_calibre != '' && valor_marca != undefined) {
        url = url + '&&caliber=' + valor_calibre;
      }
      console.log(valor_categoria + ' Rocky raccon ' + url);

      url = url + '&&crit=' + valor_criterio;

      console.log('Esta es la url: ' + url);

      axios
        .get(config_settings.RESOURCE_SERVER_URL + url)
        .then(response => {
          this.loading = false;
          this.product_duplicate = response.data.products;
          this.pages = response.data.visible_pages;
          this.final_page = response.data.final_page;
          this.current_page = 1;
          this.categoria = valor_categoria;
          this.criterio_categoria = valor_criterio;
          this.errorMessage = '';
          this.successMessage = '';
          this.id_caliber = valor_calibre;
          this.id_brand = valor_marca;
          this.listar_calibresxcate(valor_categoria);
          this.listar_marcasxate(valor_categoria);
        })
        .catch(error => {
          this.product_duplicate = [];
          this.errorMessage =
            'No se encontraron resultados de la busqueda filtrada.';
          this.successMessage = '';
          this.loading = false;
        });
    },

    listar_calibres() {
      this.childKey = this.childKey + 1;
      axios
        .get(config_settings.RESOURCE_SERVER_URL + '/GET/calibers/only_enabled')
        .then(response => {
          this.calibers = response.data;
        })
        .catch(error => {});
    },

    listar_calibresxcate(cate) {
      if (cate != '') {
        console.log('aqui calibres subcate');
        axios
          .get(
            config_settings.RESOURCE_SERVER_URL +
              '/GET/category/' +
              cate +
              '/calibers/only_enabled',
          )
          .then(response => {
            this.calibers = response.data;
          })
          .catch(error => {
            this.calibers = [];
          });
      }
    },

    listar_calibresxsubcate(subcate) {
      if (subcate != '') {
        console.log('aqui calibres subcate');
        axios
          .get(
            config_settings.RESOURCE_SERVER_URL +
              '/GET/subcategory/' +
              subcate +
              '/calibers/only_enabled',
          )
          .then(response => {
            this.calibers = response.data;
          })
          .catch(error => {
            this.calibers = [];
          });
      }
    },

    listar_marcas() {
      this.childKey = this.childKey + 1;
      axios
        .get(config_settings.RESOURCE_SERVER_URL + '/GET/brands/only_enabled')

        .then(response => {
          this.brands = response.data;
        })
        .catch(error => {});
    },

    listar_marcasxcate(cate) {
      if (cate != '') {
        this.childKey = this.childKey + 1;
        console.log('aqui marcas');
        axios
          .get(
            config_settings.RESOURCE_SERVER_URL +
              '/GET/category/' +
              cate +
              '/brands/only_enabled',
          )
          .then(response => {
            this.brands = response.data;
          })
          .catch(error => {});
      }
    },

    listar_marcasxsubcate(subcate) {
      if (subcate != '') {
        this.childKey = this.childKey + 1;
        console.log('aqui marcas subcate');
        axios
          .get(
            config_settings.RESOURCE_SERVER_URL +
              '/GET/subcategory/' +
              subcate +
              '/brands/only_enabled',
          )
          .then(response => {
            this.brands = response.data;
          })
          .catch(error => {});
      }
    },

    listar_productos() {
      this.loading = true;
      //búsqueda
      typeof this.query_filter === 'undefined'
        ? (this.query_filter = 0)
        : this.query_filter;

      typeof this.cate_filter === 'undefined'
        ? (this.cate_filter = 0)
        : this.cate_filter;
      typeof this.subcate_filter === 'undefined'
        ? (this.subcate_filter = 0)
        : this.subcate_filter;
      typeof this.crit_filter === 'undefined' || this.crit_filter == 'undefined'
        ? (this.crit_filter = 0)
        : this.crit_filter;
      typeof this.page_filter === 'undefined'
        ? (this.page_filter = 1)
        : this.page_filter;
      typeof this.caliber_filter === 'undefined'
        ? (this.caliber_filter = 0)
        : this.caliber_filter;
      typeof this.brand_filter === 'undefined'
        ? (this.brand_filter = 0)
        : this.brand_filter;

      let url = '';

      if (this.query_filter == 0) {
        if (!(this.cate_filter != 0 && this.subcate_filter == 0)) {
          if (this.caliber_filter == 0 && this.brand_filter == 0) {
            url =
              '/GET/catalog/products?xPag=' +
              this.perPage +
              '&&cat=' +
              this.subcate_filter +
              '&&crit=' +
              this.crit_filter +
              '&&nPag=' +
              this.page_filter;
          } else {
            url =
              '/GET/catalog/products-2?xPag=' +
              this.perPage +
              '&&cat=' +
              this.subcate_filter +
              '&&crit=' +
              this.crit_filter +
              '&&nPag=' +
              this.page_filter +
              '&&caliber=' +
              (this.caliber_filter == 0 ? 'disabled' : this.caliber_filter) +
              '&&brand=' +
              (this.brand_filter == 0 ? 'disabled' : this.brand_filter);
          }
        } else {
          if (this.caliber_filter == 0 && this.brand_filter == 0) {
            url =
              '/GET/catalog/productsxcategory?xPag=' +
              this.perPage +
              '&&cat=' +
              this.cate_filter +
              '&&crit=' +
              this.crit_filter +
              '&&nPag=' +
              this.page_filter;
          } else {
            url =
              '/GET/catalog/products-2xcategory?xPag=' +
              this.perPage +
              '&&cat=' +
              this.cate_filter +
              '&&crit=' +
              this.crit_filter +
              '&&nPag=' +
              this.page_filter +
              '&&caliber=' +
              (this.caliber_filter == 0 ? 'disabled' : this.caliber_filter) +
              '&&brand=' +
              (this.brand_filter == 0 ? 'disabled' : this.brand_filter);
          }
        }

        this.servicio_productos(url);
      } else {
        let data_json = {};
        if (!(this.cate_filter != 0 && this.subcate_filter == 0)) {
          url =
            '/POST/catalog/products/search_paginate?xPag=' +
            this.perPage +
            '&&crit=' +
            this.crit_filter +
            '&&nPag=' +
            this.page_filter;
          data_json = {
            query: this.query_filter,
            subcate: this.subcate_filter,
          };
        } else {
          url =
            '/POST/catalog/search_productsxcategory?xPag=' +
            this.perPage +
            '&&cat=' +
            this.cate_filter +
            '&&crit=' +
            this.crit_filter +
            '&&nPag=' +
            this.page_filter;
          data_json = {
            query: this.query_filter,
          };
        }

        this.buscar_productos(url, data_json);
      }
    },

    servicio_productos(url) {
      this.loading = true;
      axios
        .get(config_settings.RESOURCE_SERVER_URL + url)
        .then(response => {
          var arreglo = response.data.products;
          if (arreglo.length == 0) {
            this.errorMessage =
              'No existen resultados para el filtro solicitado';
          }
          this.loading = false;
          this.products_list = response.data.products;
          this.pages = response.data.visible_pages;
          this.final_page = response.data.final_page;
          this.current_page = this.page_filter;
          this.errorMessage = '';
          this.successMessage = '';
          this.showPagination = true;
        })
        .catch(error => {
          this.loading = false;
          this.showPagination = false;
          if (error.response.status === NOT_FOUND) {
            this.errorMessage = 'Sin resultado!, Inténtelo nuevamente para corroborar';
          } else {
            toastr.error(
              error.response.data.details,
              error.response.data.message,
              {
                iconClass: 'customer-danger',
              },
            );
            this.errorMessage =
              'No existen resultados para el filtro solicitado.';
            this.successMessage = '';
          }
        });
    },

    buscar_productos(url, data_json) {
      this.loading = true;
      axios({
        method: 'POST',
        url: config_settings.RESOURCE_SERVER_URL + url,
        data: data_json,
      })
        .then(response => {
          var arreglo = response.data.products;
          if (arreglo.length == 0) {
            this.errorMessage =
              'No existen resultados para el filtro solicitado';
          }
          this.loading = false;
          this.products_list = response.data.products;
          this.pages = response.data.visible_pages;
          this.final_page = response.data.final_page;
          this.current_page = this.page_filter;
          this.errorMessage = '';
          this.successMessage =
            'Estos son los resultados de la búsqueda para: ' + data_json.query;
          this.showPagination = true;
          this.scrollToTop();
        })
        .catch(error => {
          this.loading = false;
          this.showPagination = false;
          this.successMessage = '';
          if (error.response.status === 404) {
            this.errorMessage =
              'No existen resultados para la búsqueda solicitada.';
          } else {
            this.errorMessage =
              'No existen resultados para el filtro solicitado.';
          }
        });
    },

    detalleSubCategoria(valor_subcategoria) {
      axios
        .get(
          config_settings.RESOURCE_SERVER_URL +
            '/GET/catalog/categories/subcategories/' +
            valor_subcategoria,
        )
        .then(response => {
          this.detail_subcate = response.data;
          //SEO
          this.page_title = response.data.product_type_desc_es;
          this.page_description = response.data.detail_category_es;
          //this.page_keywords = response.data.keywords;
        })
        .catch(error => {});
    },

    detalleCategoria(valor_categoria) {
      axios
        .get(
          config_settings.RESOURCE_SERVER_URL +
            '/GET/catalog/categories/' +
            valor_categoria,
        )
        .then(response => {
          this.detail_cate = response.data;
          //SEO
          this.page_title = response.data.product_type_desc_es;
          this.page_description = response.data.detail_category_es;
          //this.page_keywords = response.data.keywords;
        })
        .catch(error => {});
    },

    detalleCategoriaPadre(valor_categoria_padre) {
      axios
        .get(
          config_settings.RESOURCE_SERVER_URL +
            '/GET/catalog/categories_father/' +
            valor_categoria_padre,
        )
        .then(response => {
          this.detail_cate = response.data;
          //SEO
          this.page_title = response.data.product_type_desc_es;
          this.page_description = response.data.detail_category_es;
          //this.page_keywords = response.data.keywords;
        })
        .catch(error => {});
    },
  },

  created() {
    this.scrollToTop();
    this.listar_productos();
    this.listar_categorias();
    this.listar_calibres();
    this.listar_marcas();
  },

  watch: {
    $route: function(route) {
      //SEO
      this.page_title = 'Catálogo';
      this.page_description = 'Catálogo de productos de Armaq';

      this.crit_filter = route.params.crit;
      this.page_filter = route.params.page;
      this.cate_filter = route.params.cate;
      this.subcate_filter = route.params.subcate;
      this.caliber_filter = route.params.caliber;
      this.brand_filter = route.params.brand;
      this.query_filter = route.params.query;

      this.filter_key = this.filter_key + 1;
      this.listar_productos();
    },
  },
};
</script>
<style lang="scss" src="./ProductsRedesign.scss"></style>
